import React, { useContext, CSSProperties } from 'react';

import { offset, shift } from '@floating-ui/react';
import cx from 'classnames';

import EditableText from 'components/shared/EditableText';
import Icon from 'components/shared/Icon';
import DragHandleIcon from 'components/shared/Icon/icons/DragHandleIcon';
import Trash2 from 'components/shared/Icon/icons/Trash2';
import Text from 'components/shared/Typography/Text';
import { Wysiwyg } from 'components/shared/Wysiwyg';
import { LOREM_IPSUM_TEXT } from 'constants/texts';
import { isTextBlockDefined } from 'utils/blocksHelpers/isTextBlockDefined';
import { isDefined } from 'utils/ramda';

import LandingPageContext from '../../../contexts/LandingPageContext';
import { getDefaultListItem } from '../configs';
import ListBlockItemImage from '../Image';
import s from '../index.module.css';
import { IListBlockItemProps } from './types';
import { useItem } from './useItem';

function ListBlockItem(props: IListBlockItemProps) {
  const { data, noIcon, onDelete } = props;
  const { readOnly } = useContext(LandingPageContext);
  const { attributes, listeners, setNodeRef, styleDndButton, handleChangeTitle, handleChangeDesc, handleChangeImage } =
    useItem(props);

  if (!data) return null;
  const { title, titlePlaceholder, desc, descPlaceholder, imagePlaceholder, image } = data;
  const { img } = getDefaultListItem(imagePlaceholder);

  return (
    <div className={cx(s.item, 'custom-listblock-item')} ref={setNodeRef} style={styleDndButton as CSSProperties}>
      {!readOnly && (
        <button {...attributes} {...listeners} type="button" className={s.dndButton} tabIndex={-1}>
          <Icon component={DragHandleIcon} />
        </button>
      )}
      {!noIcon && (
        <div className={cx(s.leftContent, 'custom-listblock-left')}>
          <ListBlockItemImage img={img} file={image} onChange={handleChangeImage} />
        </div>
      )}
      <div className={cx(s.rightContent, 'custom-listblock-right')} style={{ position: 'relative' }}>
        {(!readOnly || isDefined(title)) && (
          <Text size="small" isStrong className={cx(s.desc, 'custom-listblock-desc')} data-block>
            <EditableText
              text={title}
              placeholder={titlePlaceholder || 'New Fast Fact'}
              onChange={handleChangeTitle}
              isReadonly={readOnly}
            />
          </Text>
        )}

        {(!readOnly || isTextBlockDefined(desc)) && (
          <Text size="small" className={cx(s.desc, 'custom-listblock-desc')} data-block>
            {/*@ts-ignore*/}
            <Wysiwyg
              data={desc}
              placeholder={descPlaceholder || LOREM_IPSUM_TEXT}
              onChange={handleChangeDesc}
              isReadOnly={readOnly}
              toolbarFloatingOptions={{
                middleware: [offset({ mainAxis: 30 }), shift()],
              }}
            />
          </Text>
        )}
      </div>
      {!readOnly && !!onDelete && (
        <Icon
          component={Trash2}
          className={s.removeIcon}
          width="15px"
          height="16px"
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
        />
      )}
    </div>
  );
}

export default ListBlockItem;
